import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BillingButton({ pb, roomId, colors }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  // Track if we are currently checking their status, and what that status is
  const [isChecking, setIsChecking] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);

  // Check subscription status when the component mounts
  useEffect(() => {
    const checkSub = async () => {
      try {
        if (pb?.authStore?.isValid) {
          const userId = pb.authStore.record.id;
          // Look for an active subscription for this user
          await pb.collection('subscriptions').getFirstListItem(`userId="${userId}" && (status="active" || status="trialing")`);
          setHasSubscription(true);
        }
      } catch (err) {
        // A 404 here just means they don't have an active sub yet. That's perfectly fine!
        setHasSubscription(false);
      } finally {
        setIsChecking(false);
      }
    };
    checkSub();
  }, [pb]);

  const handleManageBilling = async () => {
    // If they don't have a subscription, bypass the backend completely and go straight to checkout
    if (!hasSubscription) {
      navigate(`/checkout?roomId=${roomId}`);
      return;
    }

    // If they DO have a subscription, fetch the secure Stripe Portal link
    setLoading(true);
    try {
      const res = await fetch('/api/stripe/create-portal-session', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${pb?.authStore?.token}` }
      });

      if (res.ok) {
        const data = await res.json();
        window.location.href = data.url; // Redirect to Stripe Portal
      } else {
        navigate(`/checkout?roomId=${roomId}`);
      }
    } catch (err) {
      console.error("Billing portal error:", err);
      navigate(`/checkout?roomId=${roomId}`);
    } finally {
      setLoading(false);
    }
  };

  // Determine the button text based on the state
  let buttonText = 'Subscribe';
  if (isChecking) buttonText = 'Loading...';
  else if (loading) buttonText = 'Connecting...';
  else if (hasSubscription) buttonText = 'Manage Billing';

  return (
    <button 
      onClick={handleManageBilling} 
      disabled={loading || isChecking}
      style={{
        background: 'transparent',
        color: colors.text,
        border: `1px solid ${colors.border}`,
        padding: '6px 12px',
        borderRadius: '4px',
        cursor: (loading || isChecking) ? 'not-allowed' : 'pointer',
        opacity: (loading || isChecking) ? 0.6 : 1,
        fontSize: '14px',
        transition: 'all 0.2s ease'
      }}
    >
      {buttonText}
    </button>
  );
};